import { CenterAlignedLoader } from '@medly-components/core';
import { FC, memo, Suspense, useContext } from 'react';
import { Outlet } from 'react-router-dom';

import SideNav from '../SideNav';
import { PageLayoutStyled } from './PageLayout.styled';
import { MapSearchContext } from 'context/MapSearchContext';

export const PageLayout: FC = memo(props => {
    const { isMapSearch } = useContext(MapSearchContext);
    return (
        <PageLayoutStyled id="page-layout" {...props}>
            {!isMapSearch ? <SideNav /> : null}
            <Suspense
                fallback={
                    <main>
                        <CenterAlignedLoader />
                    </main>
                }
            >
                <Outlet />
            </Suspense>
        </PageLayoutStyled>
    );
});

PageLayout.displayName = 'PageLayout';
